import { render, staticRenderFns } from "./AddToHomeDialog.vue?vue&type=template&id=11862b72&scoped=true"
import script from "./AddToHomeDialog.vue?vue&type=script&lang=ts"
export * from "./AddToHomeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11862b72",
  null
  
)

export default component.exports